import React, { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { spacing, breakpoints, fontStyle, themeLight } from '@naf/theme';
import { Close } from '@styled-icons/material/Close';
import { Text, TextVariant } from '@naf/text';
import { propValidationConfig } from '../propValidationConfig';
export const DialogIE = /*#__PURE__*/React.memo(({
  isOpen = false,
  size = 'default',
  children,
  button,
  handleClose,
  title,
  closeIcon = true,
  className
}) => {
  const close = useCallback(e => {
    if (e.key === 'Escape') {
      handleClose();
    }
  }, [handleClose]);
  useEffect(() => {
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [close]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: () => handleClose()
  }), /*#__PURE__*/React.createElement(Container, {
    className: className,
    size: size
  }, /*#__PURE__*/React.createElement(Header, null, closeIcon && /*#__PURE__*/React.createElement("button", {
    onClick: () => handleClose(),
    "aria-label": "Lukk dialogboks"
  }, /*#__PURE__*/React.createElement(Close, {
    size: 24
  }))), /*#__PURE__*/React.createElement(Inner, null, title && /*#__PURE__*/React.createElement(Text, {
    variant: TextVariant.Header3
  }, title), children), button && /*#__PURE__*/React.createElement(Footer, null, button))));
});
export default DialogIE;
const Overlay = styled.div.withConfig({
  displayName: "dialogIE__Overlay",
  componentId: "sc-1138n31-0"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background-color:'rgba(6, 46, 42, 0.5)';z-index:99;"]);
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "dialogIE__Container",
  componentId: "sc-1138n31-1"
})(["display:flex;flex-wrap:wrap;background-color:", ";position:fixed;top:50%;left:50%;overflow-y:auto;z-index:999;box-shadow:0px 0px 4px 0px rgba(0,0,0,0.15);transform:translate(-50%,-50%);", ";", " ", " @media (max-width:", "){width:100%;position:fixed;bottom:0;left:0;top:auto;max-height:100%;transform:none;", ";}"], ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, fontStyle.article.articleText, ({
  size
}) => size === 'default' && css(["max-width:560px;max-height:72%;"]), ({
  size
}) => size === 'small' && css(["max-width:420px;max-height:48%;"]), breakpoints.s, fontStyle.bodyText.bodyText);
const Header = styled.div.withConfig({
  displayName: "dialogIE__Header",
  componentId: "sc-1138n31-2"
})(["flex-basis:100%;height:", ";display:flex;justify-content:flex-end;button{margin-right:", ";margin-top:", ";padding:0;border:none;background-color:inherit;touch-action:manipulation;@media (max-width:", "){margin-right:", ";margin-top:", ";}&:hover{cursor:pointer;}}"], spacing.space48, spacing.space16, spacing.space16, breakpoints.s, spacing.space12, spacing.space20);
const Inner = styled.div.withConfig({
  displayName: "dialogIE__Inner",
  componentId: "sc-1138n31-3"
})(["margin:0 ", " ", ";display:flex;flex-direction:column;width:100%;h3{margin:0 0 ", ";}@media (max-width:", "){margin:0 ", " ", ";}"], spacing.space48, spacing.space32, spacing.space16, breakpoints.s, spacing.space24, spacing.space32);
const Footer = styled.div.withConfig({
  displayName: "dialogIE__Footer",
  componentId: "sc-1138n31-4"
})(["flex-basis:100%;margin:0 ", " ", ";button{margin-right:", ";}@media (max-width:", "){margin:0 ", " ", ";}"], spacing.space48, spacing.space48, spacing.space16, breakpoints.s, spacing.space24, spacing.space40);
//# sourceMappingURL=index.js.map